import { PrismicRichText } from 'prismic/types/richtext';
import { asText } from 'components/rich-text/RichText';

import s from './Footnotes.module.scss';
import classnames from 'classnames/bind';

const c = classnames.bind(s);

type Props = {
  footnotes: PrismicRichText;
  classname?: string;
};

export const Footnotes = ({ footnotes, classname }: Props) => {
  if (!footnotes) {
    return null;
  }

  return <p className={c(s.footnotes, classname)}>{asText(footnotes)}</p>;
};
